import React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FoundationsForGrowth() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  const benefits = ["Experienced Certified Professionals", "Fast Turnaround Times", "Comprehensive Testing Services"];
  return <section id="foundations-for-growth" ref={sectionRef} className="dark relative min-h-screen w-full overflow-hidden bg-background text-foreground flex items-center justify-center py-24 px-4">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1550713/img/soil_grass_texture.png)] bg-cover bg-center bg-fixed" />
      </div>

      {}
      {}
      <div className="absolute inset-0 z-10" style={{
      background: "radial-gradient(circle at center, color-mix(in srgb, var(--background), transparent 60%) 0%, color-mix(in srgb, var(--background), transparent 20%) 100%)"
    }} />

      {}
      <div className="relative z-20 container mx-auto max-w-[896px] flex flex-col items-center text-center gap-10">
        {}
        <h1 className={`font-sans text-5xl md:text-7xl lg:text-8xl font-black uppercase tracking-widest text-white drop-shadow-lg transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>Geotechnical Testing &amp; Investigations</h1>

        {}
        <h3 className={`font-sans text-xl md:text-2xl font-bold uppercase tracking-wide text-white/90 transition-all duration-1000 delay-300 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          Precision Geotechnical Engineering
        </h3>

        {}
        <ul className="flex flex-col md:flex-row flex-wrap justify-center gap-6 md:gap-10 mt-4">
          {benefits.map((benefit, i) => <li key={i} data-index={i} className={`flex items-center gap-3 text-lg md:text-xl font-medium text-white/90 transition-all duration-700 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: `${600 + i * 150}ms`
        }}>
              <span className="flex items-center justify-center size-8 rounded-full bg-white/10 backdrop-blur-sm border border-white/20">
                <Check className="w-5 h-5 text-primary" strokeWidth={3} />
              </span>
              {benefit}
            </li>)}
        </ul>
      </div>
    </section>;
}